import { apiRequest } from '@/utils/apiRequest'
import { apiUrl, extractCollection } from '@/utils/apiUrl'

class ServiceEventRepository {
	async getServiceEventsByDate(date, scope = 'pending') {
		const url = apiUrl(`/world/api/service-events?date=${date}&scope=${scope}`)
		try {
			const response = await apiRequest({ url, method: 'GET', expect: 'json' })
			const data = response?.data ?? response
			return extractCollection(data)
		} catch (e) {
			console.error('Error fetching service events:', e)
			return []
		}
	}
}

export const serviceEventRepository = new ServiceEventRepository()
